import i18n from 'i18n';

export const formatStepDetails = (
  details: string | Record<string, unknown> | null
): string | null => {
  if (!details) return null;
  if (typeof details === 'string') return details;

  return Object.entries(details)
    .map(([key, value]) => {
      const label = i18n.t(`${key.toUpperCase()}_KEY`, { defaultValue: key });
      const formatted = Array.isArray(value) ? value.join(', ') : String(value);
      return `${label}: ${formatted}`;
    })
    .join('; ');
};
